import React from 'react'
import DOMPurify from 'dompurify'
import PropTypes from 'prop-types'

export const Title = ({
  text,
  textColor = '',
  textAlign = '',
  lineColor = '',
  textSize = '',
  mode = 'medium',
  className = '',
  ...rest
}) => {
  switch (mode) {
    case 'tiny':
      return (
        <div
          className={`u-textSecondary u-textKernLoose ${
            textColor || 'u-textColorBrandLight'
          } ${textAlign || ''} ${className || ''}`}
          {...rest}
        >
          {text}
        </div>
      )
    case 'small':
      return (
        <div
          className={`u-textSecondary u-textBold ${
            textColor || 'u-textColorBrand'
          } ${textAlign || ''} ${textSize || 'u-textSizeMsrp1'} ${
            className || ''
          }`}
          {...rest}
        >
          {text}
        </div>
      )
    case 'small-caps':
      return (
        <div
          className={`u-textSecondary u-textUppercase ${
            textColor || 'u-textColorBrand'
          } ${textAlign || ''} ${textSize || ''} ${className || ''}`}
          {...rest}
        >
          {text}
        </div>
      )
    case 'large':
      return (
        <h1
          className={`${textColor || ''} ${textAlign || ''} ${
            textSize || 'u-sm-textSizeMsrp4 u-md-textSizeMsrp5'
          } ${className || ''}`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'medium-large':
      return (
        <h3
          className={`${textColor || ''} u-textBold ${textAlign || ''} ${
            textSize || ''
          } ${className || ''}`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'medium-large-h2':
      return (
        <h2
          className={`${textColor || ''} ${textAlign || ''} ${textSize || ''} ${
            className || ''
          }`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'medium-line':
      return (
        <div className={`${className || ''}`}>
          <h2
            className={`${textColor || 'u-textColorDefault'} ${
              textAlign || ''
            }`}
            dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
            {...rest}
          />
          <div
            className={`u-marginTop2gu ${
              lineColor || 'u-bgColorBrandExtraLight'
            }`}
            style={{ width: '100%', height: 1 }}
          />
        </div>
      )
    case 'title-case':
      return (
        <h2
          className={`${textColor || 'u-textColorDefault'} ${textAlign || ''} ${
            className || ''
          } u-textCapitalize`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'title-default':
      return (
        <h2
          className={`${textColor || 'u-textColorDefault'} ${textAlign || ''} ${
            className || ''
          } u-textNoTransform`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'medium-line-left':
      return (
        <div className={`u-flex ${className || ''}`}>
          <div
            className={`u-marginRight2gu ${
              lineColor || 'u-bgColorBrandExtraLight'
            }`}
            style={{ width: 5 }}
          />
          <h2
            className={`${'u-textColorBrand'} ${textAlign || ''}`}
            dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          />
        </div>
      )
    case 'large-line-left':
      return (
        <div className={`u-flex ${className || ''}`}>
          <div
            className={`u-marginRight3gu ${
              lineColor || 'u-bgColorBrandExtraLight'
            }`}
            style={{ width: 10, marginTop: 2 }}
          />
          <h1
            className={`${textColor || 'u-textColorBrand'} ${
              textAlign || ''
            } ${textSize || 'u-sm-textSizeMsrp4 u-md-textSizeMsrp5'}`}
            dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          />
        </div>
      )
    case 'medium':
    default:
      return (
        <h2
          className={`${textColor || 'u-textColorDefault'} ${textAlign || ''} ${
            className || ''
          } u-textDefault`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
        />
      )
  }
}

Title.propTypes = {
  text: PropTypes.string,
  textColor: PropTypes.string,
  textAlign: PropTypes.string,
  lineColor: PropTypes.string,
  textSize: PropTypes.string,
  mode: PropTypes.string,
  className: PropTypes.string,
}

export const Subtitle = ({
  text,
  textColor = '',
  lineColor = '',
  textAlign = '',
  textSize = '',
  mode = 'medium',
  className = '',
  ...rest
}) => {
  switch (mode) {
    case 'small-bold':
      return (
        <div
          className={`u-marginTop2gu u-textSecondary u-textBold ${
            textColor || 'u-textColorLight'
          } ${textAlign || ''} ${textSize || 'u-textSizeMsrm1'} ${
            className || ''
          }`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'small':
      return (
        <div
          className={`u-marginTop2gu u-textSecondary ${
            textColor || 'u-textColorLight'
          } ${textAlign || ''} ${textSize || 'u-textSizeMsrm1'} ${
            className || ''
          }`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'large':
      return (
        <div
          className={`u-marginTop2gu ${textColor || ''} ${textAlign || ''} ${
            textSize || 'u-textSizeMsrp2'
          } ${className || ''}`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'medium-large':
      return (
        <h3
          className={`u-marginBottom4gu ${textColor || ''} ${textAlign || ''} ${
            textSize || 'u-textSizeMsrp3'
          } ${className || ''}`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
    case 'line':
      return (
        <div className={`u-marginBottom4gu`}>
          <div
            className={`${
              lineColor || 'u-bgColorBrandExtraLight'
            } u-marginBottom1gu`}
            style={{ width: '100%', height: 4 }}
          ></div>
          <div
            className={`u-textUppercase u-textBold u-textSecondary ${
              textColor || ''
            } ${textAlign || ''} ${textSize || ''} ${className || ''}`}
            dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          />
        </div>
      )
    case 'line-left':
      return (
        <div className={`u-flex u-marginBottom4gu`}>
          <div
            className={`${
              lineColor || 'u-bgColorBrandExtraLight'
            } u-marginRight1gu`}
            style={{ width: 5, height: '100%' }}
          ></div>
          <div
            className={`${textColor || ''} ${textAlign || ''} ${
              textSize || ''
            } ${className || ''}`}
            dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          />
        </div>
      )
    case 'quote':
      return (
        <>
          <span className="Icon--material material-icons Icon--material-quote u-posRelative u-textSizeMsrp7 u-marginBottom3gu">
            format_quote
          </span>
          <h3
            className={`u-marginBottom6gu u-textNormal u-textOpen ${
              textColor || ''
            } ${textAlign || ''} ${textSize || ''} ${className || ''}`}
            dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
            {...rest}
          />
        </>
      )
    case 'medium':
    default:
      return (
        <p
          className={`u-marginTop2gu ${textColor || ''} ${textAlign || ''} ${
            textSize || 'u-textOpen'
          } ${className || ''}`}
          dangerouslySetInnerHTML={{ __html: fixTrademark(text) }}
          {...rest}
        />
      )
  }
}

Subtitle.propTypes = {
  text: PropTypes.string,
  textColor: PropTypes.string,
  lineColor: PropTypes.string,
  textAlign: PropTypes.string,
  textSize: PropTypes.string,
  mode: PropTypes.string,
  className: PropTypes.string,
}

const fixTrademark = (text) => {
  const _text = DOMPurify.sanitize(text)
  return _text?.replaceAll('®', '<sup>®</sup>')
}
